var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-card',{attrs:{"bordered":false}},[_c('custom-page-table',{ref:"tableList",staticStyle:{"margin-top":"16px"},attrs:{"queryParams":_vm.queryParams,"columns":_vm.columns,"base-key":"orderUrl","params-path":"order/queryZWYOrderList"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }